module.exports = __webpack_public_path__ + "img/check.a8c7ba82.svg";